<template>
  <svg 
    :width="width" 
    :height="height" 
    viewBox="0 0 28 24" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    class="televisao-icon"
  >
    <path 
      d="M24.1633 6.57178H10.2382C9.88861 6.57178 9.60522 6.85516 9.60522 7.20474V16.6991C9.60522 17.0487 9.88861 17.3321 10.2382 17.3321H24.1633C24.5129 17.3321 24.7963 17.0487 24.7963 16.6991V7.20474C24.7963 6.85516 24.5129 6.57178 24.1633 6.57178Z" 
      :stroke="color" 
      stroke-linecap="round" 
      stroke-linejoin="round"
    />
    <path 
      d="M19.7327 17.332L22.2645 20.4968" 
      :stroke="color" 
      stroke-linecap="round" 
      stroke-linejoin="round"
    />
    <path 
      d="M14.669 17.332L12.1372 20.4968" 
      :stroke="color" 
      stroke-linecap="round" 
      stroke-linejoin="round"
    />
    <path 
      d="M14.6689 12.2683V14.1672" 
      :stroke="color" 
      stroke-linecap="round" 
      stroke-linejoin="round"
    />
    <path 
      d="M17.2009 11.0024V14.1672" 
      :stroke="color" 
      stroke-linecap="round" 
      stroke-linejoin="round"
    />
    <path 
      d="M19.7327 9.73657V14.1673" 
      :stroke="color" 
      stroke-linecap="round" 
      stroke-linejoin="round"
    />
    <path 
      d="M17.2009 6.57173V4.67285" 
      :stroke="color" 
      stroke-linecap="round" 
      stroke-linejoin="round"
    />
    <path 
      d="M1.92614 3.29367C2.02164 2.89986 2.58171 2.89986 2.6772 3.29367L2.93995 4.37724C2.97405 4.51784 3.08382 4.62761 3.22442 4.66171L4.308 4.92446C4.7018 5.01995 4.7018 5.58003 4.308 5.67552L3.22442 5.93827C3.20685 5.94253 3.18976 5.94797 3.17323 5.95451C3.05756 6.00029 2.96979 6.09971 2.93995 6.22274L2.6772 7.30631C2.67124 7.33092 2.66345 7.354 2.65408 7.37553C2.51352 7.69858 2.01567 7.67551 1.92614 7.30631L1.66339 6.22274C1.66126 6.21395 1.65884 6.20528 1.65613 6.19675C1.61546 6.06871 1.51074 5.97023 1.37893 5.93827L0.295352 5.67552C0.270739 5.66955 0.247665 5.66177 0.226129 5.6524C-0.0969123 5.51183 -0.073838 5.01398 0.295352 4.92446L1.37893 4.66171C1.51952 4.62761 1.6293 4.51784 1.66339 4.37724L1.92614 3.29367Z" 
      :fill="color"
    />
    <path 
      d="M7.5675 8.29634C7.5675 8.80482 7.1553 9.21702 6.64683 9.21702C6.13836 9.21702 5.72616 8.80482 5.72616 8.29634C5.72616 7.78786 6.13836 7.37566 6.64683 7.37566C7.1553 7.37566 7.5675 7.78786 7.5675 8.29634Z" 
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  name: 'TelevisaoIcon',
  props: {
    color: {
      type: String,
      default: '#4B089F'
    },
    width: {
      type: [String, Number],
      default: 24
    },
    height: {
      type: [String, Number],
      default: 24
    }
  }
}
</script>

<style scoped>
.televisao-icon {
  display: inline-block;
  vertical-align: middle;
}
</style>
